//Formik
import { useField, useFormikContext } from "formik"
import _, { forEach } from "lodash"

//PrimeReact
import { Button } from "primereact/button"
import { Column } from "primereact/column"
import { TreeTable } from "primereact/treetable"
import { Tooltip } from "primereact/tooltip"
import { Accordion, AccordionTab } from "primereact/accordion"
import { SelectButton } from "primereact/selectbutton"

//Styles
import kioskStyles from "../../../../styles/kiosk/KioskAdmin.module.css"
import myStyles from "../../../../styles/kiosk/KioskAdminFormWizard.module.css"

import CustomTooltip from "../Utils/CustomTooltip"
import WizardPageFieldsNodeCheckbox from "./WizardPageFieldsNodeCheckboxBody"
import WizardPageFieldsNodeName from "./WizardPageFIeldsNodeName"
import { useEffect, useState } from "react"
import { classNames } from "primereact/utils"

export default function WizardPageFields({ onBack, onNext }) {
  const { setFieldValue } = useFormikContext()

  const [field, , fieldHelpers] = useField("fields")
  const [fieldNodes] = useField("fieldNodes")

  const [expandedKeys, setExpandedKeys] = useState(null)
  const [groupedBlocks, setGroupedBlocks] = useState([])
  const [showSystemFields, setShowSystemFields] = useState(true)

  useEffect(() => {
    if (fieldNodes.value) {
      const parentNodes = GetParentNodes(fieldNodes.value)
      setExpandedKeys(parentNodes)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      fieldNodes.value &&
      _.isArray(fieldNodes.value) &&
      !_.isEmpty(fieldNodes.value)
    ) {
      //Get a unique list of blocks from the fieldNodes
      let tempBlocks = (fieldNodes.value || [])
        .map((node) => node?.data?.blockName) // Safely access blockName
        .filter((name) => name != null && String(name).trim() !== "") // Filter out null, undefined, and empty/whitespace-only names

      // Remove duplicates
      tempBlocks = [...new Set(tempBlocks)]

      const blockGroups = tempBlocks.map((blockName) => {
        return {
          name: blockName,
          fields: fieldNodes.value?.filter(
            (node) => node.data.blockName === blockName
          ),
        }
      })

      setGroupedBlocks(blockGroups)
    } else {
      setGroupedBlocks([])
    }
  }, [fieldNodes.value])

  function GetParentNodes(nodeList) {
    let parentNodes = {}

    nodeList
      .filter((node) => node.children?.length > 0)
      .forEach((node) => {
        parentNodes[node.key] = true

        //Look for any children that have children
        let childKeys = GetParentNodes(node.children)

        if (_.keys(childKeys).length > 0) {
          parentNodes = { ...parentNodes, ...childKeys }
        }
      })

    return parentNodes
  }

  const requiredColumnHeader = () => {
    return (
      <>
        <CustomTooltip
          label={"Toggle to mark the field as required or optional."}
          position={"bottom"}
          targetId={"table_required_header"}
        />
        <label
          className={`${myStyles.fieldHeader} ${myStyles.tableFieldHeader}`}
        >
          Required
          <i
            className={`pi pi-info-circle ${kioskStyles.info}`}
            id={"table_required_header"}
          ></i>
        </label>
      </>
    )
  }
  const showColumnHeader = () => {
    return (
      <>
        <CustomTooltip
          label={"Toggle to show or hide the field."}
          position={"bottom"}
          targetId={"table_show_header"}
        />
        <label
          className={`${myStyles.fieldHeader} ${myStyles.tableFieldHeader}`}
        >
          Show
          <i
            className={`pi pi-info-circle ${kioskStyles.info}`}
            id={"table_show_header"}
          ></i>
        </label>
      </>
    )
  }

  const fieldHeader = () => {
    return (
      <label className={`${myStyles.fieldHeader} ${myStyles.tableFieldHeader}`}>
        Field
      </label>
    )
  }

  const rowClass = (node) => {
    let classObject = {}

    classObject[myStyles.fieldRowWithParent] = node.data.hasParent
    classObject[myStyles.fieldRow] = !node.data.hasParent

    return classObject
  }

  const hideAllFields = () => {
    let newFields = _.cloneDeep(field.value)
    let wasUpdated = false

    newFields.forEach((field) => {
      if (!field.systemRequired && !field.removed && field.show) {
        field.show = false
        field.required = false
        wasUpdated = true
      }
    })

    if (wasUpdated) {
      fieldHelpers.setValue(newFields)
    }
  }

  const showAllFields = () => {
    let newFields = _.cloneDeep(field.value)
    let wasUpdated = false

    newFields.forEach((field) => {
      if (!field.systemRequired && !field.removed && !field.show) {
        field.show = true
        wasUpdated = true
      }
    })

    if (wasUpdated) {
      fieldHelpers.setValue(newFields)
    }
  }

  const requireAllFields = () => {
    let newFields = _.cloneDeep(field.value)
    let wasUpdated = false

    newFields.forEach((field) => {
      if (!field.systemRequired && !field.removed && !field.required) {
        field.show = true
        field.required = true
        wasUpdated = true
      }
    })

    if (wasUpdated) {
      fieldHelpers.setValue(newFields)
    }
  }

  const requireNoFields = () => {
    let newFields = _.cloneDeep(field.value)
    let wasUpdated = false

    newFields.forEach((field) => {
      if (!field.systemRequired && !field.removed && field.required) {
        field.required = false
        wasUpdated = true
      }
    })

    if (wasUpdated) {
      fieldHelpers.setValue(newFields)
    }
  }

  const QuickButton = ({ icon, tooltip, onClick }) => {
    return (
      <Button
        type="button"
        onClick={onClick}
        tooltip={tooltip}
        tooltipOptions={{ position: "bottom", className: "custom-tooltip" }}
        className={kioskStyles.roundedButton}
        icon={`pi ${icon}`}
      />
    )
  }

  return (
    <>
      <div className={myStyles.fieldQuickActionsLayout}>
        <div className={classNames(myStyles.fieldQuickActionsSystem)}>
          Customization
        </div>
        <div className={myStyles.fieldQuickActionsShow}>
          <QuickButton
            icon={"pi-eye"}
            tooltip={"Show all fields"}
            onClick={showAllFields}
          />
        </div>
        <div className={myStyles.fieldQuickActionsHide}>
          <QuickButton
            icon={"pi-eye-slash"}
            tooltip={"Hide all non-system required fields"}
            onClick={hideAllFields}
          />
        </div>
        <div className={myStyles.fieldQuickActionsRequire}>
          <QuickButton
            icon={"pi-check-circle"}
            tooltip={"make all fields required"}
            onClick={requireAllFields}
          />
        </div>
        <div className={myStyles.fieldQuickActionsOptional}>
          <QuickButton
            icon={"pi-circle"}
            tooltip={"Make all non-system required fields optional"}
            onClick={requireNoFields}
          />
        </div>
      </div>

      <div className={myStyles.fieldsLayout}>
        <div
          className={`${myStyles.fieldsLayoutTable} ${myStyles.treeTableStyle}`}
        >
          <Tooltip target=".systemRequiredField" />

          {groupedBlocks.map((block) => {
            return (
              <Accordion
                multiple
                activeIndex={_.keys(groupedBlocks).map((key) => +key)}
              >
                <AccordionTab
                  header={block.name}
                  headerClassName={myStyles.accordionHeader}
                >
                  <TreeTable
                    value={block.fields}
                    rowClassName={rowClass}
                    expandedKeys={expandedKeys}
                    onToggle={(e) => setExpandedKeys(e.value)}
                  >
                    <Column
                      field="fieldLabel"
                      header={fieldHeader()}
                      expander
                      className={myStyles.fieldColumnStyle}
                      body={(rowData) => (
                        <WizardPageFieldsNodeName
                          rowData={rowData}
                          fields={field.value}
                        />
                      )}
                    ></Column>
                    <Column
                      field="required"
                      header={requiredColumnHeader()}
                      className={myStyles.fieldColumnCheckboxStyle}
                      body={(rowData) => (
                        <WizardPageFieldsNodeCheckbox
                          rowData={rowData}
                          fields={field.value}
                          fieldName={"required"}
                        />
                      )}
                    ></Column>
                    <Column
                      field="show"
                      header={showColumnHeader()}
                      className={myStyles.fieldColumnCheckboxStyle}
                      body={(rowData) => (
                        <WizardPageFieldsNodeCheckbox
                          rowData={rowData}
                          fields={field.value}
                          fieldName={"show"}
                        />
                      )}
                    ></Column>
                  </TreeTable>
                </AccordionTab>
              </Accordion>
            )
          })}
        </div>
        <div
          className={`${myStyles.fieldsLayoutActions} ${myStyles.buttonGroup}`}
        >
          <Button
            label="Back"
            type="button"
            onClick={() => {
              onBack()
            }}
            className={`${kioskStyles.button}`}
          />
          <Button
            label="Next"
            type="button"
            onClick={() => {
              onNext()
            }}
            className={`${kioskStyles.button} ${kioskStyles.primaryButton}`}
          />
        </div>
      </div>
    </>
  )
}
